/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTehtrisStatuses200ResponseStatusesInner
 */
export interface GetTehtrisStatuses200ResponseStatusesInner {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the GetTehtrisStatuses200ResponseStatusesInner interface.
 */
export function instanceOfGetTehtrisStatuses200ResponseStatusesInner(value: object): value is GetTehtrisStatuses200ResponseStatusesInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetTehtrisStatuses200ResponseStatusesInnerFromJSON(json: any): GetTehtrisStatuses200ResponseStatusesInner {
    return GetTehtrisStatuses200ResponseStatusesInnerFromJSONTyped(json, false);
}

export function GetTehtrisStatuses200ResponseStatusesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTehtrisStatuses200ResponseStatusesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function GetTehtrisStatuses200ResponseStatusesInnerToJSON(json: any): GetTehtrisStatuses200ResponseStatusesInner {
    return GetTehtrisStatuses200ResponseStatusesInnerToJSONTyped(json, false);
}

export function GetTehtrisStatuses200ResponseStatusesInnerToJSONTyped(value?: GetTehtrisStatuses200ResponseStatusesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

